import { marketplaces } from './amazon-search.js';
export type AmazonStore = {
  brand: string;
  country: string;
  url: string;
  evidenceUrl: string;
  checkedAt: string;
  kind?: 'STOREFRONT' | 'BRAND_SEARCH';
  verified?: boolean;
};
// A brand's own Amazon storefront (an amazon.*/stores/ page, which Amazon grants only to the
// registered brand owner) is an official store: once checked it is marked verified. Its link is
// tagged at click time like every Amazon link. Brand searches are navigation, not a storefront, and
// stay unverified. Keep each supplied marketplace: never substitute another country's domain.
export const amazonStores: AmazonStore[] = [
  {
    brand: 'French Avenue',
    country: 'BE',
    kind: 'BRAND_SEARCH',
    url: 'https://www.amazon.com.be/s?rh=n%3A27156023031%2Cp_4%3AFRENCH%2BAVENUE&language=en',
    evidenceUrl:
      'https://www.amazon.com.be/s?rh=n%3A27156023031%2Cp_4%3AFRENCH%2BAVENUE&language=en',
    checkedAt: '2026-09-07T00:00:00Z',
    verified: false,
  },
  {
    brand: 'Lattafa',
    country: 'BE',
    kind: 'BRAND_SEARCH',
    url: 'https://www.amazon.com.be/s?rh=n%3A27156023031%2Cp_4%3ALattafa&language=en',
    evidenceUrl: 'https://www.amazon.com.be/s?rh=n%3A27156023031%2Cp_4%3ALattafa&language=en',
    checkedAt: '2026-09-07T00:00:00Z',
    verified: false,
  },
  {
    brand: 'Afnan',
    country: 'GB',
    kind: 'STOREFRONT',
    url: 'https://www.amazon.co.uk/stores/AFNANPERFUMES/page/AFAEB470-CD70-4B01-8038-AC8AA2320F13',
    evidenceUrl:
      'https://www.amazon.co.uk/stores/AFNANPERFUMES/page/AFAEB470-CD70-4B01-8038-AC8AA2320F13',
    checkedAt: '2026-09-23T00:00:00Z',
    verified: true,
  },
  {
    brand: 'Armaf',
    country: 'GB',
    kind: 'STOREFRONT',
    url: 'https://www.amazon.co.uk/stores/ARMAF/page/69AFF386-5FB8-4F58-8775-B1ABFC1C7B92',
    evidenceUrl: 'https://www.amazon.co.uk/stores/ARMAF/page/69AFF386-5FB8-4F58-8775-B1ABFC1C7B92',
    checkedAt: '2026-09-23T00:00:00Z',
    verified: true,
  },
];
export function amazonStore(
  country: string,
  brand: string,
  stores = amazonStores,
  now = Date.now(),
) {
  const supplied =
    stores.find(
      (store) =>
        store.country === country &&
        store.brand.toLowerCase() === brand.toLowerCase() &&
        Number.isFinite(Date.parse(store.checkedAt)) &&
        Date.parse(store.checkedAt) <= now &&
        now - Date.parse(store.checkedAt) < 90 * 86400000,
    ) ?? null;
  if (supplied) return supplied;
  // A constructed brand search is navigation, not a verified storefront or availability claim.
  const supportedBrand = ['French Avenue', 'Lattafa', 'Afnan', 'Armaf'].find(
    (b) => b.toLowerCase() === brand.toLowerCase(),
  );
  if (stores !== amazonStores || !supportedBrand || !marketplaces[country]) return null;
  const url = new URL('https://' + marketplaces[country] + '/s');
  url.searchParams.set('k', supportedBrand + ' perfume');
  url.searchParams.set('rh', 'p_4:' + supportedBrand);
  return {
    brand: supportedBrand,
    country,
    url: url.href,
    evidenceUrl: '',
    checkedAt: '',
    kind: 'BRAND_SEARCH' as const,
    verified: false,
  };
}
